import React, { useState, useEffect } from "react";
import api from "../../axios/api";
import "../../assets/NewFiles/Css/Dashboard.css";
import { ToastContainer } from "react-toastify";
import { Pagination, Box, TableContainer, Table, Paper, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import BulkUserModal from "./BulkUserModal";
import AddIcon from "@mui/icons-material/Add";
import Loader from "../common/Loader";
import Button from "../common/styled components/Button";
import { PlusIcon } from "lucide-react";

const EmployeeTable = () => {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const rowsPerPage = 10;

  const [isBulkUserModalOpen, setIsBulkUserModalOpen] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      setIsLoading(true); // Set loading state to true
      try {
        const response = await api.get("/api/user/getemployees");
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }finally {
        setIsLoading(false); // Set loading state to false after fetching

      }
    };

    fetchUsers();
  }, []);

  const filteredUsers = users.filter(
    (user) => user.role_code !== "admin" && user.role_code !== "superadmin"
  );

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  // Calculate pagination
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedUsers = filteredUsers.slice(startIndex, endIndex);
  const pageCount = Math.ceil(filteredUsers.length / rowsPerPage);


  return (
    <div>
    <Box sx={{ width: "100%", margin: "auto", padding: 2 }}>
      <Button
        startIcon={<AddIcon />}
        onClick={() => setIsBulkUserModalOpen(true)}
        sx={{ ml: 3 }}
      >
        <PlusIcon size={18} className="mr-2"/>Create Multiple Users
      </Button>
      <BulkUserModal
        open={isBulkUserModalOpen}
        onClose={() => setIsBulkUserModalOpen(false)}
      />
      <ToastContainer />
      {isLoading && (
                <div className="loading-overlay" style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                  zIndex: 1000,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}>
                  <Loader />
                </div>
              )}
              <div className={isLoading ? 'content-disabled' : ''} style={{
                pointerEvents: isLoading ? 'none' : 'auto',
                opacity: isLoading ? 0.6 : 1,
                transition: 'opacity 0.3s'
              }}>
      <Box sx={{ padding: 2 }}>
        {/* <div style={{fontSize:'30px',fontWeight:'bold',margin:'10px'}}> My Employees</div> */}
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: "#002F43" }}>
              <TableRow>
                <TableCell sx={{ color: "#fff" }}>Full Name</TableCell>
                <TableCell sx={{ color: "#fff" }}>Email</TableCell>
                <TableCell sx={{ color: "#fff" }}>Total Trees</TableCell>
                <TableCell sx={{ color: "#fff" }}>Verified Trees</TableCell>
                <TableCell sx={{ color: "#fff" }}>Last Login</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedUsers.map((user) => (
                <TableRow key={user.id}>
                  <TableCell>{user.full_name}</TableCell>
                  <TableCell>{user.userEmail}</TableCell>
                  <TableCell>{user.totalTrees}</TableCell>
                  <TableCell>{user.verifiedTrees}</TableCell>
                  {user.lastLogin ? (
                    <TableCell>
                      {new Date(user.lastLogin).toLocaleString()}
                    </TableCell>
                  ) : <TableCell style={{ textAlign: 'center' }}>
                    -
                  </TableCell>}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}
        >
          <Pagination
            count={pageCount}
            page={page}
            onChange={handlePageChange}
            color="primary"
            className="pagination-container"
          />
        </Box>
      </Box>
      </div>
    </Box>
    </div>
  );
};

export default EmployeeTable;
